import httpService from '@/modules/common/services/httpService';

const baseRoute = 'v2/conversations';

const fetchConversations = ({
  folder = 'inbox', page = 1, perPage = 25, teamsViewFilter = null,
} = {}) => {
  const params = { folder, page, per_page: perPage };
  if (teamsViewFilter) params.teams_view_filter = teamsViewFilter;
  return httpService.get(baseRoute, params).then((res) => res.data);
};

const fetchCounts = () => httpService.get(`${baseRoute}/counts`).then((res) => res.data);

const getConversation = (uid) => httpService.get(`${baseRoute}/${uid}`, { full_client: true }).then((res) => res.data);

// flags: { business_unread, spam, archived, deleted, follow_up, follow_up_date, ... }
const updateConversation = (uid, flags) => httpService.put(`${baseRoute}/${uid}`, flags).then((res) => res.data);

const assignConversation = (uid, staffId, notes) => httpService
  .post(`${baseRoute}/${uid}/assignments`, { staff_id: staffId, notes, type: 'conversation' })
  .then((res) => res.data);

const sendLead = (uid, staffIds, notes) => httpService
  .post(`${baseRoute}/${uid}/assignments`, { staff_ids: staffIds.join(','), notes, type: 'send_lead' })
  .then((res) => res.data);

const fetchSources = () => httpService.get('v2/sources').then((res) => res.data);

const setInboxSidePane = (status) => httpService
  .put('v2/staffs_frontage/set_inbox_side_pane_status', { inbox_side_pane: status })
  .then((res) => res.data);

export default {
  fetchConversations,
  fetchCounts,
  getConversation,
  updateConversation,
  assignConversation,
  sendLead,
  fetchSources,
  setInboxSidePane,
};
